<template>
    <div class="errorpage">
        <h3>
            FEHLER
        </h3>
        <div>
            {{ message }}
        </div>        
        <div class='backlink' v-if="backlink">
            <router-link :to="backlink">Zurück</router-link>
        </div>        
    </div>    
</template>

<script>
export default {
    name: "Errorpage",
    props: { 
        message: String, 
        backlink: String
    },
    created() {
        this.$parent.setBacklink(this.backlink);
    },
    data() {
        return {
        };
    },    
    methods: {
    }
};
</script>

<style lang="css" src="../assets/css/Error.css"/>